<template>
  <div class="bottom_bar">
    <div class="bottom_menu">
      <div  class="toggle_button" @click="toggleBottomBar(this.$refs.menu)">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="this.mainStore.isBottomBarActive === false">
        <circle cx="23" cy="23" r="23" fill="#2A282C" />
        <line x1="11" y1="14" x2="35" y2="14" stroke="white" stroke-width="2" stroke-linecap="round"/>
        <line x1="11" y1="22" x2="35" y2="22" stroke="white" stroke-width="2" stroke-linecap="round"/>
        <line x1="11" y1="30" x2="35" y2="30" stroke="white" stroke-width="2" stroke-linecap="round"/>
        </svg>

        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" v-show="this.mainStore.isBottomBarActive === true">
        <circle cx="24" cy="24" r="24" fill="white"/>
        <line x1="14.9795" y1="15.0101" x2="32.7494" y2="32.78" stroke="#2A282C" stroke-width="2" stroke-linecap="round"/>
        <line x1="14.6087" y1="32.3786" x2="32.3786" y2="14.6087" stroke="#2A282C" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
      <div ref="menu" class="menu_bar">
        <a class="link" href="/aviso_legal.html" target="_blank"><span>AVISO LEGAL</span></a>
        <span>POLITICA DE COOKIES</span>
      </div>
    </div>
    <div class="button_sound" @click="toggleSound()" >
<svg  v-show="this.mainStore.isMuted === true" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
<circle class="st0" cx="50" cy="50" r="50"/>
<g>
<g>
<path class="st1" d="M26.2,72.4l25.4-19.3l25.4-19.3"/>
</g>
<polygon class="st2" points="35.8,45.1 60.7,26.5 60.7,73.5 35.8,59.8 26.6,59.8 26.6,45.1 	"/>
<g>
<path class="st3" d="M23.7,69.1l25.4-19.3l25.4-19.3"/>
</g>
</g>
</svg>

<svg  v-show="this.mainStore.isMuted === false" version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 100 100" style="enable-background:new 0 0 100 100;" xml:space="preserve">
<circle style="fill:#2B282C;" cx="50" cy="50" r="50"/>
<g>
	<path style="fill:none;stroke:#FFFFFF;stroke-width:4;stroke-linecap:square;stroke-linejoin:round;" d="M66.5,42.2
		c2.6,2.8,6.3,9.9,0,16.2 M74.7,35.5c4.2,5,10.1,17.8,0,29 M28.9,45.1l24.9-18.6v47L28.9,59.8h-9.2V45.1H28.9z"/>
</g>
</svg>
</div>
  </div>
</template>

<script>
import {useMainStore} from '@/stores/mainStore';
import {bottomMenuShow} from '@/helpers/animations';

export default {
  name: "BottomBar",
  setup(){
    const mainStore = useMainStore();
    return {mainStore}
  },
  methods: {
    toggleSound: function () {
      console.log(this.mainStore.isMuted);
      if (this.mainStore.isMuted === true) {
        this.mainStore.isMuted = false;
        document.getElementById("ambient_audio").play();
      } else if (this.mainStore.isMuted === false) {
        this.mainStore.isMuted = true;
        document.getElementById("ambient_audio").pause();
      }
    },
    toggleBottomBar: function(a){
        bottomMenuShow(a)
    }
  },
};
</script>

<style scoped>
.bottom_bar {
  position: absolute;
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  padding: 0px 10px 0px 10px;
  z-index: 1;
  bottom: 10px;
}
.bottom_menu {
  z-index: 1;
  display: flex;
  flex-direction: row;
}
.button_sound{
  width:48px;
}
.toggle_button{
    width: 48px;
    height: 48px;
    border-radius: 24px;
    align-self: center;
}
span{
    font-family: 'cervo';
    color:#fff;
    align-self: center;
    padding: 0 10px 0 10px;
    font-size:18px;
    
}

.link{
  align-self: center;
  text-decoration: none;
}
.menu_bar{
    background-color: #2B282C;
    display: flex;
    border-radius: 0 24px 24px 0;
    transform: scale(0);
}
</style>